<template>
        <div>
                <el-dialog
                        :visible.sync="dialogVisible"
                        width="70%"
                        :title="title"
                        append-to-body
                        :modal-append-to-body='false'
                        :show-close='false'
                        :close-on-press-escape='false'
                        :close-on-click-modal="false"
                       
                        >

                        <avue-form
                                :option="option"
                                v-model="form"
                                v-if="dialogVisible"
                                ref="form"
                                @submit="(form,done)=>applyFor(1,form,done)"
                                @error="formError"
                        >
                        <template slot="warehouseId">
                                <el-select v-model="form.warehouseId"
                                        :disabled="disabled"
                                >
                                        <el-option
                                                v-for="item in warehouseList"
                                                :key="item"
                                                :value="item.id"
                                                :label="item.name"
                                        >

                                        </el-option>
                                </el-select>
                        </template>
                        <!-- <template slot="requisitionUser">
                                <avue-input-tree
                                        v-model="form.requisitionUser"
                                        :dic="userlist"
                                >

                                </avue-input-tree>
                        </template> -->
                        <template slot="requisitionDept">
                                <el-select v-model="form.requisitionDept"
                                        :disabled="disabled"
                                >
                                        <el-option
                                                v-for="item in deptList"
                                                :key="item"
                                                :value="item.id"
                                                :label="item.fullName"
                                        >

                                        </el-option>
                                </el-select>
                        </template>
                        
                                <template slot="menuForm">
                                        <!-- <el-button
                                                v-if="editable"
                                                @click="applyFor(1)"
                                                type="primary">
                                                保存
                                        </el-button> -->
                                        <el-button
                                                v-if="editable"
                                                :loading="loading"
                                                @click="applyFor(2)"
                                          type="primary">
                                                提交
                                        </el-button>
                                        <el-button
                                                v-if="!editable && auditBtn"
                                                @click="openAduitDialog"
                                                type="primary">
                                                审核
                                        </el-button>
                                        <el-button
                                                v-if="!editable && printBtn"
                                                @click="print"
                                          >
                                                打印
                                        </el-button>
                                        <el-button 
                                         :loading="loading"
                                        @click="applyFor(3)">
                                                取消
                                        </el-button>
                                </template>
                                <template slot="dataList">
                                        <div>
                                          <ConsumableSelector
                                                :showSum='true'
                                                ref="cs"
                                                :columns="csColumns"
                                                :numberMode="numberMode"
                                                :numberKey="csNumKey"
                                                :priceKey="csPriceKey"
                                                :data.sync="csData"
                                                :projectId="this.form.projectId"
                                                @loadData="loadData"
                                                :priceMode="priceMode"
                                                @loadPrice="loadPrice"
                                                :editable="editable"
                                                @afterAdd="csDataAfterAdd"
                                                :priceValidate="false"
                                                :scene="'out'"
                                                />
                                        </div>
                                       
                                </template>
                        </avue-form>
                        
                </el-dialog>
                <el-dialog
                        :visible.sync="aduitDialog"
                        width="40%"
                        title="审核"
                        append-to-body
                        :close-on-click-modal="false"
                        v-loading="aduitloading"
                        >
                        <el-row>
                                <el-col>
                                        <el-form ref="aduitform" :model="aduitform" label-width="80px">
                                                <el-form-item label="审核备注" 
                                                        required
                                                        prop="remark"
                                                        :rules="[{ required: true, message: '请填写备注', trigger: 'change' },
                                                        { required: true, message: '请填写备注', trigger: 'blur' }]"
                                                >
                                                        <el-input 
                                                        placeholder="请输入备注信息"
                                                        type="textarea"
                                                        maxlength="300"
                                                        show-word-limit
                                                        rows="5"
                                                        v-model="aduitform.remark"></el-input>
                                                </el-form-item>
                                        </el-form>
                                </el-col>
                        </el-row>
                        <div style="display:flex;justify-content: center;">
                                <el-button
                                 type="primary"
                                               
                                                @click="aduit(3)"
                                          >
                                                通过
                                </el-button>
                                <el-button @click="aduit(4)">
                                        驳回
                                </el-button>
                        </div>
                        
                </el-dialog>
        </div>
</template>
<script>
import formOption from "./recipients-from-option";
import ConsumableSelector from '@/components/consumable-selector/index';
import {
        applyFor,
        getDetail,
        getDegetConsumableListByRequisitionIdtail,
        aduit,
        viewUpdateConsumableList,
        getWarehouseListApply,//获取仓库下拉列表
        treeDeptsByIds,//当前登录人获取科室
        deptUserlist
    } from "@/api/warehouseRequisition/warehouserequisition";
import {
  getProjectList,
  getWarehouseList,
  getDict,
  consumableList,
  getBusinessNo
} from "@/api/crmedical/warehouse/index.js";
import {
  treeByProjectDeptId,

} from "@/api/crmedical/group/group";
import {mapGetters} from "vuex";
import treeVue from '../../../../../packages/config/tree.vue';
export default {
        components:{
                ConsumableSelector
        },
        props:{

        },
        data(){
                
                return{
                        title:'',
                        editFirst:true,
                        auditBtn:false,
                        printBtn:false,
                        numberMode:'input',
                        priceMode:'normal',
                        aduitform:{},
                        aduitloading:false,//审核表单提交状态样式
                        aduitDialog:false,//审核弹窗
                        deptList:[],
                        disabled:false,
                        loading:false,
                        option:formOption,
                        dialogVisible:false,
                        csData:[],
                        csColumns: [
                                { label: "序号", prop: "", type: "index", width: 50 },
                                { label: "物品", prop: "name" },
                                { label: "编号", prop: "code" },
                                { label: "分类", prop: "typeName" },
                                { label: "单位", prop: "measuringUnitName" },
                                { label: "品牌", prop: "brand" },
                                { label: "规格", prop: "specification" },
                                { label: "生产商", prop: "manufacturer" },
                                { label: "出库单价", prop: "price" },
                                { label: "库存数量", prop: "stockNum" },
                                { label: "领用数量", prop: "inboundNum" },
                                { label: "领用金额", prop: "rowSum" },
                                
                                {
                                label: "剩余可数量领用",
                                prop: "surplus",
                                maxCheck: true,
                                hide: true,
                                },
                        ],
                        pageLoading: false,
                        prjectList: [],
                        userlist:[],
                        warehouseList: [],
                        warehouseInboundTypeList: [],
                        inboundStatusList: [],
                        dicts: {},
                        editable: "add", 
                        form: {
                                projectId: "",
                                warehouseId: "",
                                type: "",
                                inboundStatus: "",
                                inboundNo: "",
                                linkNo: "",
                                id:'',
                        },
                        addDialogVisible: false,
                        data: [], //入库单列表
                        csData: [],
                        submitFlag:true,
                        mode:'',
                }
        },
        created() {
                this.fetchData();
        },
        watch:{
                'form.projectId'(val,oldval){
                        if(!this.form.projectId){
                                return;
                        }
                        if(this.title != '查看'){
                                this.csData = [];
                        }
                        
                        this.getWarehouseList();
                },
                'form.warehouseId'(val,oldval){

                        if(this.title == '查看'){
                                return;
                        }
                        if(val){
                                this.viewUpdateConsumableList(this.csData);
                        }
                       
                },
                'form.requisitionDept'(val,oldval){
                        
                        if(val){
                                if(this.title == '申请'){
                                        this.form.requisitionUser = this.userInfo.user_id;
                                }else if(this.title == '编辑'){
                                        console.log('编辑测试')
                                        if(!this.editFirst){
                                                this.form.requisitionUser = this.userInfo.user_id;
                                        }else{
                                             this.editFirst = false;   
                                        }
                                        
                                }

                                this.deptUserlist()
                        }
                }

               
        },
         computed: {
            ...mapGetters(['userInfo']),
            
           
        },
        methods:{
                // 根据科室获取人
                deptUserlist(){
                        deptUserlist({deptId:this.form.requisitionDept}).then(res=>{
                                let requisitionUsercolumn  = this.findObject(this.option.column, "requisitionUser");
                                requisitionUsercolumn.dicData = res.data;
                        })
                        
                },
                // 根据当前登录人获取科室
                treeDeptsByIds(){
                        
                        treeDeptsByIds().then(res=>{
                                this.deptList = res.data;
                                if(this.title=='申请'){
                                        this.form.requisitionDept = this.deptList[0]?this.deptList[0].id:'';
                                }
                        })
                },
                // 获评变动后回调
                csDataAfterAdd(data,all){
                        this.viewUpdateConsumableList(all);
                },
                // 查询单价
                viewUpdateConsumableList(all){
                        let params = {
                                warehouseId:this.form.warehouseId,
                                inboundConsumableList:all||this.csData
                        }
                        viewUpdateConsumableList(params).then(res=>{
                                this.csData.forEach((ele,index)=>{
                                      ele.price = res.data[index].stockPrice; 
                                      ele.stockNum =  res.data[index].stockNum 
                                })
                                this.$refs.cs.calcSums();
                                // this.csData = res.data;
                        })
                },
                // 打开审核弹窗
                openAduitDialog(){
                        this.aduitDialog = true;
                },
                // 审核
                aduit(status){
                        this.aduitform.status = status;
                         this.$refs.aduitform.validate(valid=>{
                                 if(valid){
                                        aduit(this.aduitform).then(res=>{
                                               this.$message({
                                                        message: '操作成功',
                                                        type: 'success'
                                                });
                                                this.aduitform.remark = '';
                                                this.aduitDialog = false;
                                                this.dialogVisible = false;
                                                this.$emit('onLoad');
                                        })
                                 }else{

                                 }
                         })
                       
                },
                // 打印
                print(){
                        this.$message({
                                message: '该功能暂未开放',
                                type: 'warning'
                        });
                },
                // 打开弹窗页面
                openDialog(data){
                        this.treeDeptsByIds();
                        this.form={
                                warehouseId:'',
                                projectId:'',
                                id:'',
                        };
                        this.submitFlag = true;
                        this.csData = [];
                        let projeCtcolumn  = this.findObject(this.option.column, "projectId");
                        projeCtcolumn.dicData = data.dicData.projectIdDictDataList;
                        
                        
                        // userlist
                        // let requisitionUsercolumn  = this.findObject(this.option.column, "requisitionUser");
                        // requisitionUsercolumn.dicData = data.dicData.userlist;
                        data.dicData.userlist.forEach(item=>{
                        item.label = item.realNameAndPhone;
                        item.value = item.userId;
                        })
                        this.userlist = data.dicData.userlist;
                        this.option.submitBtn = true;
                        this.auditBtn = false;
                        this.disabled = false;
                        if(data.type=='add'){
                                this.title = '申请';
                                this.numberMode = 'input';
                                this.editable = true;
                                this.priceMode='normal';
                                this.mode = 'no-first';    
                                this.form.projectId=data.dicData.projectIdDictDataList[0].id?data.dicData.projectIdDictDataList[0].id:'';
                                this.form.requisitionUser = this.userInfo.user_id;
                                // let deptId = 
                                // this.form.requisitionDept = this.userInfo.dept_id;

                                this.form.id = '';
                                this.form.requisitionTime = new Date();
                                getBusinessNo({businessType:3}).then(res=>{
                                        this.form.requisitionNo = res.data;
                                })
                                
                                
                                this.getWarehouseList();
                                this.option.disabled = false;
                                this.dialogVisible = true;
                        }
                        if(data.type=='view'){
                                this.option.submitBtn = false;
                                this.title = '查看';
                                this.numberMode = 'mormal';
                                this.editable = false;
                                this.printBtn = false;
                                this.mode = 'first';
                                this.disabled = true;
                                this.aduitform.id = data.data.id;
                                this.getDetail(data.data.id,(detail)=>{
                                        this.form = detail;
                                        this.form.projectId = detail.projectId;
                                        this.form.requisitionDept =detail.requisitionDept;
                                        this.form.requisitionUser =detail.requisitionUser;
                                        this.form.remark = detail.remark;
                                        this.form.requisitionNo = detail.requisitionNo;
                                        if(detail.requisitionStatus==2 && data.auditBtn){
                                                this.auditBtn = true;
                                        }
                                        if(
                                                detail.requisitionStatus == 3
                                                || detail.requisitionStatus == 4
                                                || detail.requisitionStatus == 5
                                                || detail.requisitionStatus == 6
                                                || detail.requisitionStatus == 7
                                                || detail.requisitionStatus == 8
                                        ){
                                                this.printBtn = true;
                                        }

                                })
                                
                                this.getDegetConsumableListByRequisitionIdtail(data.data.id);
                                this.option.disabled = true;

                        }
                        if(data.type=='edit'){
                                this.title = '编辑';
                                this.numberMode = 'input';
                                this.editable = true;
                                this.editFirst = true;
                                this.mode = 'first';
                                this.aduitform.id = data.data.id;
                                this.getDetail(data.data.id,(detail)=>{
                                        this.form = detail;
                                        this.form.projectId = detail.projectId;
                                        this.form.requisitionDept =detail.requisitionDept;
                                        this.form.requisitionUser =detail.requisitionUser;
                                        this.form.remark = detail.remark;
                                        this.form.requisitionNo = detail.requisitionNo;
                                })
                                
                                this.getDegetConsumableListByRequisitionIdtail(data.data.id);
                                this.option.disabled = false;
                                // this.dialogVisible = true;
                        }
                        
                        
                },
                getDetail(id,callback){
                        getDetail({id:id}).then(res=>{
                                callback(res.data);
                        })
                },
                formError(done){
                        done();
                },
                // 保存 提交    
                applyFor(type,form,done){
                        if(done){
                                done()
                        }
                        if(type==3){
                                this.dialogVisible = false;
                                this.$emit('onLoad');
                                return;
                        }
                        let validateResult = this.$refs.cs.validate(); 
                        if(!validateResult){
                                console.log(validateResult)
                                return;
                        }
                        let flag = true;
                        this.csData.forEach(ele=>{
                                
                                let a= Number(ele.inboundNum)
                                if(ele.inboundNum == '' || Number(ele.inboundNum)<1){
                                        flag = false;
                                }
                        })
                        if(!flag){
                                this.$message({
                                                message: '请输入正确得领用数量',
                                                type: 'warning'
                                        });
                                return;
                        }
                        if(this.csData.length<1 && type!=3){
                                if(type==1){
                                        this.$message({
                                                message: '请选择申请物品后再保存',
                                                type: 'warning'
                                        });
                                }else{
                                        this.$message({
                                                message: '请选择申请物品后再提交',
                                                type: 'warning'
                                        });
                                }
                                
                                return;
                        }
                        this.$refs.form.validate((valid) => {
                                
                                if (valid) {
                                       
                                        this.form.requisitionStatus = type;
                                                                               
                                        this.form.requisitionTime = this.dayjs(this.form.requisitionTime).format('YYYY-MM-DD HH:mm:ss')
                                         if(!this.submitFlag){
                                                 return;
                                                
                                        }
                                        this.submitFlag = false;
                                        this.loading = true;
                                        this.form.requisitionConsumableList = [];
                                        this.csData.forEach(ele=>{
                                                let temObj = {
                                                        consumableId:ele.consumableId,
                                                        requisitionNum:ele.inboundNum,
                                                        price:ele.price,
                                                };
                                                this.form.requisitionConsumableList.push(temObj);
                                        })
                                        applyFor(this.form).then(res=>{
                                                this.form.id = res.data.id;
                                                this.submitFlag = true;
                                                this.loading = false;
                                                if(type==1){
                                                        this.$message({
                                                                message: '保存成功',
                                                                type: 'success'
                                                        });
                                                        this.$refs.crud.toggleSelection();
                                                        this.option.disabled = false;
                                                }else{
                                                        this.$message({
                                                                message: '提交成功',
                                                                type: 'success'
                                                        });
                                                        this.dialogVisible = false;
                                                        this.$emit('onLoad');
                                                }
                                        }).catch(res=>{
                                                this.submitFlag = true;
                                                this.loading = false;
                                        })




                                } else {
                                        
                                return false;
                                }
                                if(done){
                                        done()   
                                }
                        });
                        

                        
                },
                // 根据id获取材料清单
                getDegetConsumableListByRequisitionIdtail(id){
                        getDegetConsumableListByRequisitionIdtail({requisitionId:id}).then(res=>{
                                res.data.forEach(ele=>{
                                        ele.rowSum =  ele.inboundNum*ele.price;
                                        ele.rowSum = ele.rowSum.toFixed(2);
                                        
                                })
                                this.csData = res.data;
                                this.dialogVisible = true;
                        })
                },
                // 获取仓库列表 科室列表
                getWarehouseList(){
                        if(this.mode=='first'){
                        }else{
                                this.form.warehouseId = '';
                        }
                        getWarehouseListApply({projectId:this.form.projectId}).then(res=>{
 
                                this.warehouseList = res.data;

                                 if(this.mode!='first'){
                                        this.form.warehouseId=this.warehouseList[0]?this.warehouseList[0].id:'';

                                 }
                        })
                     
                },
              
                
                loadData(query, resolve) {
                        query.name = query.text;
                        const params = { ...query, projectId: this.form.projectId };
                        const columns = [
                                { label: "分类", prop: "typeName" },
                                { label: "编号", prop: "code" },
                                { label: "名称", prop: "name" },
                                { label: "计量单位", prop: "measuringUnitName" },
                                { label: "品牌", prop: "brand" },
                                { label: "规格", prop: "specification" },
                        ];
                        consumableList(params).then((res) => {
                                res.data.records.forEach((element) => {
                                element.id = "";
                                });
                                resolve(res.data, columns);
                        });
                },
                loadPrice(query, resolve) {
                        setTimeout(() => {
                                resolve(10.0);
                        }, 500);
                        },
                        async fetchData() {
                        this.pageLoading = true;
                        try {
                                //projectList
                                const resProjectList = await getProjectList();
                                this.prjectList = resProjectList.data;
                                this.form.projectId = this.prjectList[0]
                                ? this.prjectList[0].id
                                : "";
                                //warehouseList
                                const resWarehouseList = await getWarehouseList({
                                projectId: this.form.projectId,
                                });
                                this.warehouseList = resWarehouseList.data;

                                this.form.warehouseId = this.warehouseList[0]
                                ? this.warehouseList[0].id
                                : "";
                                //type && status
                                const dicts = await Promise.all([
                                getDict({ code: "warehouse_inbound_type" }),
                                getDict({ code: "inbound_status" }),
                                ]);
                                this.warehouseInboundTypeList = dicts[0].data;
                                this.form.type = this.warehouseInboundTypeList[0].dictKey;
                                this.inboundStatusList = dicts[1].data;
                                this.form.inboundStatus = this.inboundStatusList[0].dictKey;
                                //load list
                                // this.loadList();
                        } catch (err) {
                        }
                        this.pageLoading = false;
                },
        }
}
</script>
